import React from 'react';
import VistaFabbisogno from './fabbisogni/VistaFabbisogno';

// ─────────────────────────────────────────────────────────────────────────────
// FabbisogniSubappalti — vista in tempo reale dei fabbisogni di subappalti
// (lavorazioni), calcolata da ordini confermati e distinte confermate.
// L'intera pagina è implementata dal componente condiviso VistaFabbisogno.
// ─────────────────────────────────────────────────────────────────────────────
export default function FabbisogniSubappalti() {
  return (
    <VistaFabbisogno
      categoria="subappalti"
      titolo="Fabbisogni Subappalti"
      permessoModulo="commerciale.fabbisogni_subappalti"
    />
  );
}
